import { render, staticRenderFns } from "./ModalCarrierEdit.vue?vue&type=template&id=930985ca&scoped=true"
import script from "./ModalCarrierEdit.vue?vue&type=script&lang=js"
export * from "./ModalCarrierEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalCarrierEdit.vue?vue&type=style&index=0&id=930985ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "930985ca",
  null
  
)

export default component.exports